import React, { useState } from 'react';
import { Button, Card, Alert, Spinner } from 'react-bootstrap';
import authApi from '../../api/authApi';
import AppToast from '../AppToast';

/**
 * Tab component for User details page to resend welcome email / password reset link.
 * @param {Object} props.recordData - The user record data from DetailLayout
 */
const UserWelcomeEmailTab = ({ recordData, recordId }) => {
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', variant: 'success' });
  console.log("recordData   ---", recordData);
  const handleResendEmail = async () => {
    if (!recordData) return;
    console.log("recordData   ---", recordData);
    console.log("recordId   ---", recordId);

    setLoading(true);
    try {
      const result = await authApi.resendUserWelcomeEmail(recordId);
      if (result.success) {
        setToast({
          show: true,
          message: 'Forgot password email has been resent successfully!',
          variant: 'success'
        });
      } else {
        setToast({
          show: true,
          message: result.message || 'Failed to resend forgot password email.',
          variant: 'danger'
        });
      }
    } catch (error) {
      console.error('Error resending Forgot Password email:', error);
      setToast({
        show: true,
        message: 'An error occurred while trying to resend the forgot password email.',
        variant: 'danger'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-3">
      <Card className="shadow-sm border-0">
        <Card.Body>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div>
              <h5 className="mb-1 text-primary">User Onboarding</h5>
              <p className="text-muted small mb-0">
                Send or resend the forgot password email with a password reset link to this user.
              </p>
            </div>
            <i className="fas fa-envelope-open-text fa-2x text-light"></i>
          </div>

          <Alert variant="info" className="border-0 bg-light">
            <div className="d-flex">
              <i className="fas fa-info-circle mt-1 me-3 text-info"></i>
              <div>
                <strong>Important:</strong> This will send an email to
                <span className="text-primary fw-bold mx-1">{recordData || 'the user\'s email'}</span>
                containing a secure link to set their password. The link will be valid for 24 hours.
              </div>
            </div>
          </Alert>

          <div className="mt-4">
            <Button
              variant="outline-primary"
              onClick={handleResendEmail}
              disabled={loading || !recordData}
              className="px-4 py-2 d-flex align-items-center"
            >
              {loading ? (
                <>
                  <Spinner size="sm" className="me-2" animation="border" />
                  Sending...
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane me-2"></i>
                  Forgot Password Email
                </>
              )}
            </Button>
            {!recordData && (
              <p className="text-danger small mt-2">
                <i className="fas fa-exclamation-triangle me-1"></i>
                User does not have an email address configured.
              </p>
            )}
          </div>
        </Card.Body>
      </Card>

      <AppToast
        show={toast.show}
        message={toast.message}
        variant={toast.variant}
        onClose={() => setToast({ ...toast, show: false })}
      />
    </div>
  );
};

export default UserWelcomeEmailTab;
